module.exports = __webpack_public_path__ + "static/media/Pet.86c5fdf2.svg";